export default __webpack_public_path__ + "static/media/Yuan400.ef5b8f89.svg";